export const productXx = [
    {
        id: 'xx001',
        date: '2022-03-10',
        image: '/gcal/01.png',
        name: '2022年嵩县公路廊道绿化提升项目',
        shortDescription: '主要内容为嵩县县城至旧县段公路廊道景观绿化提升，包含苗木栽植、道路硬化铺装、挡墙砌筑、小品构件安装等。此项目涉及绿化、市政专业。'
    },
    {
        id: 'xx002',

        date: '2025-01-15',
        image: '/gcal/02.jpg',
        name: '洛阳市涧西区体育局2025年全民健身器材采购项目',
        shortDescription: '主要内容为洛阳市涧西区体育局采购的20套全民健身器材的采购及安装，每套健身器材包括双位漫步机、二位蹬力器、腰背按摩器、棋牌桌、儿童跷跷板、健骑机、划船器、上肢牵引器。此项目涉及设备采购专业。'
    },
    {
        id: 'xx003',
        date: '2023-06-20',
        image: '/gcal/03.png',
        name: '洛阳新能源产业园城中村改造项目(一期)安置地块四',
        shortDescription: '洛阳新能源产业园城中村改造项目（一期）安置地块四，位于洛阳市伊滨区龙顾路北侧，孔明街西侧，项目用地北侧和西侧均未规划道路。本项目分为南北两个地块，总建筑面积22.83万平方米。项目包含9栋高层住宅楼、1栋商住楼、地下车库以及幼儿园、物业用房、大门等配套设施。此项目涉及建筑、装饰、电气、给排水暖通等专业。'
    },
    {
        id: 'xx004',

        date: '2023-09-05',
        image: '/gcal/04.jpg',
        name: '栾川县重渡沟管委会北乡村通村道路和河堤防护修复以工代赈示范项目',
        shortDescription: '主要内容修建平凉河沟口至王坪黄家岭全长 2.9 公里、宽 6.5 米的道路，具体施工内容有在原有路面铺设水稳层及沥青层、设置管涵，以及修建浆砌石挡墙护堰、浆砌石堰坝等。此项目涉及公路与市政专业。'
    },
    {
        id: 'xx005',
        date: '2024-02-28',
        image: '/gcal/05.jpg',
        name: '九龙山温泉怡养酒店提质改造项目',
        shortDescription: '主要内容包括为九龙山温泉怡养酒店内部住宿区、汤池区、餐厅、品茗区、室外区域、5#楼宿舍、厂区大门、场外道路及其余零星改造等。此项目涉及建筑、装饰、电气、给排水、暖通、市政等专业。'
    },
    {
        id: 'xx006',
        date: '2023-11-12',
        image: '/gcal/06.jpg',
        name: '汝阳县玉马水库灌区续建配套与节水改造项目',
        shortDescription: '主要为玉马灌区5条干渠和1条支渠清淤，衬砌加固，拆除重建破损渠道及渠道恢复，同时对现状隧洞、渡槽、水闸、路涵等建筑物加固及拆除重建，开展灌区信息化建设，形成较为完整的灌排体系。此项目涉及水利工程专业。'
    },
    {
        id: 'xx007',

        date: '2024-04-30',
        image: '/gcal/07.jpg',
        name: '环山路提升改造建设项目',
        shortDescription: '主要内容为破除清运原道路结构层，新建沥青混凝土路面结构，新建波形护栏，新建空心六棱块护坡，铺设路缘石，立设交通标志及涂刷标线，栽植乔木及植草等。此项目涉及公路工程专业。'
    },
    {
        id: 'xx008',
        date: '2023-08-18',
        image: '/gcal/08.png',
        name: '伊滨区郑洛高速新建工程通信迁改项目',
        shortDescription: '主要内容为线路迁改工程，包含顶管、光缆的铺设，新建水泥杆、铁塔架等，此项目涉及通信专业。'
    }
]